import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { isMobile, isTablet } from 'react-device-detect';
import { connect } from 'react-redux';
import Initicon from 'react-initicon';
import { bindActionCreators } from 'redux';
import { Dropdown, Icon, Image } from 'semantic-ui-react';

import { map, get } from '../utils/lodash';
import { threeDotSeparator } from '../utils';
import { INSTANCE_FIXED_LANGUAGE } from '../utils/instanceConstant';

import {
  logoutUser,
  revertImpersonation,
  setSidebarType,
} from '../store/actions';

import { isIndividualUser } from '../utils/activity/userPermission';
import { SIDEBAR_TYPES } from '../utils/constant';
import LanguageSwitcher from './i18n/LanguageSwitcher';
import LanguageBadge from './i18n/LanguageBadge';
import { LocaleService } from '../services';

import './styles.scss';

const SIGN_OUT_ITEM = { key: 'sign-out', text: 'Log Out', value: '/' };

const REVERT_ITEM = {
  key: 'revert',
  text: '↩ Revert to admin',
  value: '__revert__',
};

function buildOptions(base, impersonatedBy) {
  return impersonatedBy
    ? [...base, REVERT_ITEM, SIGN_OUT_ITEM]
    : [...base, SIGN_OUT_ITEM];
}

const BASE_GO_TO_ADMIN = (t) => [
  { key: 'user', text: t('sidebar.user_profile'), value: '/user-profile' },
  {
    key: 'admin-activity',
    text: t('sidebar.go_to_admin'),
    value: '/admin/activity-settings',
  },
  { key: 'help', text: t('sidebar.help_label'), value: '/help' },
];

const BASE_TO_GO_HOME = (t) => [
  { key: 'user', text: t('sidebar.user_profile'), value: '/user-profile' },
  {
    key: 'home',
    text: t('sidebar.go_to_home'),
    value: '/dashboard',
  },
  { key: 'help', text: t('sidebar.help_label'), value: '/help' },
];

const BASE_FOR_USER = (t) => [
  { key: 'user', text: t('sidebar.user_profile'), value: '/user-profile' },
  { key: 'help', text: t('sidebar.help_label'), value: '/help' },
];

class Profile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  async getAction(route) {
    const { logoutUser, revertImpersonation, navigate, setSidebarType } =
      this.props;

    switch (route) {
      case '/':
        await logoutUser(navigate);
        break;

      case '__revert__':
        await revertImpersonation(navigate);
        break;

      default:
        navigate(route);
        // hide side bar
        setSidebarType(SIDEBAR_TYPES[0], false);
        break;
    }
  }

  render() {
    let { t, user, isAdminRoute, impersonatedBy } = this.props;

    const file = get(user, 'organisation.logo.documentUrl', null);
    const name = get(user, 'organisation.name', get(user, 'name', ''));

    const options =
      user.role === 'admin'
        ? isAdminRoute
          ? buildOptions(BASE_TO_GO_HOME(t), impersonatedBy)
          : buildOptions(BASE_GO_TO_ADMIN(t), impersonatedBy)
        : buildOptions(BASE_FOR_USER(t), impersonatedBy);

    return (
      <div className="dropdown-adjust user-profile-dropdown">
        <Dropdown
          pointing="top left"
          inline
          selectOnBlur={false}
          icon={null}
          trigger={
            /**
             * Note: user-profile-drop class name used for help tip showing class name (don't change it or remove it)
             */
            <div className="user-profile-drop">
              {!file ? (
                <Initicon size={32} text={name} seed={23} single={true} />
              ) : (
                <Image
                  src={file}
                  className="img-wid"
                  alt="logo"
                  size="mini"
                  rounded
                />
              )}
              <div className="name-wid">
                {/*
                 * Note: user-pro-panel class name used for help tip showing class name (don't change it or remove it)
                 */}
                <span className="user-pro-panel">
                  {isMobile ? (
                    isTablet ? (
                      <>
                        <label className="user-pro-text">
                          {`${user.name}`.substring(0, 10)}
                        </label>
                        <label className="user-sub-text">{name}</label>
                      </>
                    ) : null
                  ) : (
                    <div className="user-info">
                      <div>
                        <label className="user-pro-text">
                          {threeDotSeparator({
                            name: user.name,
                            length: 17,
                            isPopUp: false,
                          })}
                        </label>
                        <Icon
                          className="icon-re"
                          name="caret down"
                          size="large"
                        />
                      </div>

                      <div className="name-badge-ctr">
                        <label className="user-sub-text">
                          {user.role === 'guest'
                            ? t('sidebar.guest_account')
                            : isIndividualUser(user)
                              ? t('sidebar.individual_account')
                              : name}
                        </label>
                        {!INSTANCE_FIXED_LANGUAGE && <LanguageBadge />}
                      </div>
                    </div>
                  )}
                </span>
              </div>
              {/* <Icon className="icon-re" name="caret down" size="large" /> */}
            </div>
          }
        >
          <Dropdown.Menu>
            {user.role === 'guest' ? null : (
              <div className="disabled-item">
                <div className="drop-in-userName">
                  {!file ? (
                    <Initicon size={32} text={name} seed={23} single={true} />
                  ) : (
                    <Image
                      src={file}
                      className="img-wid"
                      alt="logo"
                      size="mini"
                      rounded
                    />
                  )}
                  <div className="user-pro-text">
                    {threeDotSeparator({
                      name: name,
                      length: 15,
                      isPopUp: false,
                    })}
                  </div>
                </div>
              </div>
            )}

            {map(options, (item, idx) => {
              return (
                <Dropdown.Item
                  key={idx}
                  onClick={() => this.getAction(item.value)}
                >
                  <div className="text-color">{item.text}</div>
                </Dropdown.Item>
              );
            })}

            {!INSTANCE_FIXED_LANGUAGE && (
              <Dropdown.Item key="lang">
                <LanguageSwitcher context="profile-menu" />
              </Dropdown.Item>
            )}

            {/******* for handy testing of locale
            <div>{LocaleService.fmtLocaleDate('2026-10-03T12:00:00', { month: 'short', year: 'numeric' })}</div>
            <div>{LocaleService.fmtLocaleNumeral(12345678)}</div>
            <div>{LocaleService.fmtLocaleCurrency(23456.467)}</div>
            <div>{LocaleService.fmtLocaleCurrencyWholeDollars(23456.467)}</div>
            <div>{LocaleService.fmtLocaleCurrencyCompact(123_453_123.467)}</div>
            *************/}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.authentication,
    impersonatedBy: state.authentication.impersonatedBy,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logoutUser,
      revertImpersonation,
      setSidebarType,
    },
    dispatch
  );
};

Profile = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Profile));

export { Profile };
